#import "../shift/shiftInfo.gql"

fragment availabilityOverrideInfo on AvailabilityOverride {
  line {
    id
    name
  }
  shift {
    ...shiftInfo
  }
  overrideDate
  available
}
